import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RvtShortcutSvg = function RvtShortcutSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#prefix__a)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#CAD0E4",
        fillRule: "evenodd",
        d: "M2 0h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H8.708A9 9 0 0 0 0 9.223V2a2 2 0 0 1 2-2",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "url(#prefix__b)",
        fillRule: "evenodd",
        d: "m15.495 11.797.305-2.318-3.518-5.415-4.31 2.304-.532 4.462a9 9 0 0 1 3.37 5.326l6.962 3.713 1.138-1.729-5.57-5.896z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "url(#prefix__c)",
        fillRule: "evenodd",
        d: "M12.282 4.064 15.8 9.48l-2.99-1.133z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "url(#prefix__d)",
        fillRule: "evenodd",
        d: "m15.495 11.797.305-2.318-2.99-1.133.53 3.898z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "url(#prefix__e)",
        fillRule: "evenodd",
        d: "m10.81 16.156 6.962 3.713 1.138-1.729-5.57-5.896-3.148 1.068-.11.725c.327.664.574 1.375.729 2.119",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "url(#prefix__f)",
        fillRule: "evenodd",
        d: "m10.192 13.312.835-3.569 2.313 2.501z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "url(#prefix__g)",
        fillRule: "evenodd",
        d: "m12.282 4.064-1.316 5.707 2.374 2.473z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#25285F",
        fillRule: "evenodd",
        d: "m7.972 6.368 3.05 3.375.423-1.907z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "url(#prefix__h)",
        fillRule: "evenodd",
        d: "M7.44 10.83a9 9 0 0 1 1.931 2.005l.82.477.83-3.569-3.049-3.375z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#1E1C4E",
        fillRule: "evenodd",
        d: "m12.282 4.064-4.31 2.304 3.473 1.468z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#272F69",
        fillRule: "evenodd",
        d: "m10.083 14.037.109-.725-.283.39q.09.165.174.335",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "url(#prefix__i)",
        fillRule: "evenodd",
        d: "m9.909 13.701.283-.39-.467.07q.096.158.184.32",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#121325",
        fillRule: "evenodd",
        d: "m9.725 13.38.467-.068-.821-.477q.187.266.354.545",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "url(#prefix__j)",
        fillRule: "evenodd",
        d: "m12.838 8.36-1.393-.524.837-3.772z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "currentColor",
        d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
      })]
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "prefix__b",
        x1: 13.741,
        x2: 8.619,
        y1: 19.837,
        y2: 12.66,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#293D7B"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.995,
          stopColor: "#263A7D"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "prefix__c",
        x1: 14.268,
        x2: 12.9,
        y1: 9.367,
        y2: 7.017,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#293D7B"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.995,
          stopColor: "#263A7D"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "prefix__d",
        x1: 14.814,
        x2: 13.232,
        y1: 11.851,
        y2: 9.281,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#2F4687"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#224083"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "prefix__e",
        x1: 13.144,
        x2: 15.008,
        y1: 17.275,
        y2: 14.627,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: 0.005,
          stopColor: "#27397C"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#253C7F"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "prefix__f",
        x1: 11.815,
        x2: 11.332,
        y1: 13.066,
        y2: 10.852,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#201D50"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#24285D"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "prefix__g",
        x1: 12.272,
        x2: 12.087,
        y1: 8.35,
        y2: 8.303,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#272C66"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#27326F"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "prefix__h",
        x1: 8.977,
        x2: 9.835,
        y1: 12.421,
        y2: 8.909,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#14133E"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#212053"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "prefix__i",
        x1: 8.645,
        x2: 8.617,
        y1: 14.567,
        y2: 14.018,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: 0.005,
          stopColor: "#212053"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#232459"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "prefix__j",
        x1: 12.141,
        x2: 12.263,
        y1: 8.12,
        y2: 5.838,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#27316D"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#28326F"
        })]
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "prefix__a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      })]
    })]
  });
};
export var RvtShortcut = function RvtShortcut(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: RvtShortcutSvg
  }));
};